<script lang="ts">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { formatNumber, getStr, globalCurrencyTag, type JoodMembershipType } from '../../../../../common/util';

  import { getJoodCardImageUrlNew } from '../../../../product-details/services/pdp-data-services';
  import Icon from '../../Icon.svelte';

  import JoodExpire from './JoodExpire.svelte';

  export let priceType: JoodMembershipType;
  export let displayPrice: number;
  export let isProductCard = false;

  const { joodExpiredFlag, encodedContextPath, lang, joodFullCappingLimitReached } = getAppConfig();

  $: cardImageUrl = getJoodCardImageUrlNew(priceType, false, 26);

  $: formattedPriceHtml = getStr('jood.price.with.currency', [
    globalCurrencyTag,
    `<strong>${formatNumber(displayPrice)}</strong>`,
  ]);

  const showExpireCard = Boolean(joodExpiredFlag);
  const joodSubscribeLinkHref = `${encodedContextPath}/jood/benefits`;
</script>

{#if displayPrice > 0 && !joodFullCappingLimitReached}
  <section class="jood-saving-section c_jooddiscountpricecard {isProductCard ? 'product-card' : ''}">
    <div class="jood-saving-container expired-{joodExpiredFlag}">
      {@html formattedPriceHtml}

      <span class="vat">
        {getStr('extra.addtocart.inc.of.vat')}
      </span>

      <img src={cardImageUrl} alt="Jood Card" loading="lazy" />
    </div>

    {#if showExpireCard}
      <JoodExpire place="price-expire-card" />
    {:else}
      <a class="subscribe-upgrade-link" on:click|stopPropagation href={joodSubscribeLinkHref}>
        {getStr('extra.prime.become.jood.member.start.saving.text')}
        <Icon type="font" glyph={lang === 'en' ? 'chevron_right' : 'chevron_left'} mobileSize={12} />
      </a>
    {/if}
  </section>
{/if}

<style lang="scss">
  @import '../../../../common/styles/colors.new.scss';

  .jood-saving-section {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: -20px;
    &.product-card {
      margin-top: 4px;
      @include responsive {
        flex-direction: column;
        gap: 0;
        align-items: flex-start;
      }
      .jood-saving-container {
        :global {
          .c_global-currency-sign,
          .price {
            font-size: 12px;
            @include responsive {
              font-size: 14px;
            }
          }
          img {
            width: 24px;
            margin-left: auto;
          }
        }
      }
      :global {
        .subscribe-upgrade-bottom {
          padding: 2px;
          .c_expirecard {
            white-space: nowrap;
          }
          .c_infoicon {
            .checkoutPriceCard {
              width: 8px;
            }
          }
          .expired-text-container {
            font-size: 10px;
            gap: 2px;
            @include responsive {
              font-size: 9px;
            }
            &.isPLP {
              font-size: 5px;
            }

            .renewal-link {
              i {
                font-size: 8px;
              }
            }
            &.expired-text-BASIC,
            &.expired-text-VIP {
              span {
                border-right: none;
                padding-right: 6px;
              }
            }
          }
        }
      }
    }

    .jood-saving-container {
      display: flex;
      align-items: center;
      gap: 2px;

      padding: 2px 4px;
      border-radius: 4px;

      background: $jood-gold-light;
      border: 0.5px solid #89661e;

      img {
        width: 26px;
        border-radius: 2px;
        object-fit: contain;
      }

      &.expired-BASIC {
        background: $jood-blue-light;
        border: 0.5px solid $icon-only-icon-blue;
        @include responsive {
          gap: 4px;
        }
      }
      &.expired-SMART {
        background: #cfefed;
        border: 0.5px solid #006b68;
        @include responsive {
          gap: 4px;
        }
      }
      :global {
        .c_global-currency-sign,
        .price {
          font-size: 16px;
          line-height: 20px;
          color: $neutral-dark-01;
        }
        .expired-text-container {
          display: flex;
          gap: 2px;
          white-space: nowrap;
          span {
            font-size: 9px;
            line-height: 11px;
          }
        }
        .c_infoicon {
          display: flex;
        }
        .renewal-link {
          font-size: 9px;
          line-height: 11px;
        }
      }
    }

    .vat {
      font-size: 6px;
      font-weight: 400;
      line-height: 14px;
      white-space: nowrap;
      color: $neutral-dark-01;
    }

    .disclaimer {
      color: $neutral-dark-01;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
    }
    .subscribe-upgrade-link {
      align-items: center;
      gap: 4px;
      display: flex;
      color: $jood-gold-text;
      font-size: 12px;
    }
  }
</style>
